var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('question-title',{staticClass:"mb1",attrs:{"question":_vm.question}}),_c('div',{staticClass:"control mt1"},[_c('masked-input',{staticClass:"input",attrs:{"type":"tel","name":"phone","placeholder":"Phone","placeholderChar":"_","mask":[
          /[1-9]/,
          /\d/,
          /\d/,
          '-',
          /\d/,
          /\d/,
          /\d/,
          '-',
          /\d/,
          /\d/,
          /\d/,
          /\d/
        ]},nativeOn:{"keyup":function($event){return _vm.recordAnswer($event)}},model:{value:(_vm.choice),callback:function ($$v) {_vm.choice=$$v},expression:"choice"}})],1),_c('next-button',{attrs:{"id":_vm.question.id,"choice":_vm.choice}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }